import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import { FormsModule } from '@angular/forms';
// import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSpinnerModule } from "ngx-spinner"; 

import {AppRoutingModule} from '@/app-routing.module';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import {AppComponent} from './app.component';
import {MainComponent} from '@modules/main/main.component';
import {LoginComponent} from '@modules/login/login.component';
import {HeaderComponent} from '@modules/main/header/header.component';
import {FooterComponent} from '@modules/main/footer/footer.component';
import {MenuSidebarComponent} from '@modules/main/menu-sidebar/menu-sidebar.component';
import {BlankComponent} from '@pages/blank/blank.component';
import {ReactiveFormsModule} from '@angular/forms';
import {ProfileComponent} from '@pages/profile/profile.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RegisterComponent} from '@modules/register/register.component';
import {DashboardComponent} from '@pages/dashboard/dashboard.component';
import {ToastrModule} from 'ngx-toastr';
import {MessagesComponent} from '@modules/main/header/messages/messages.component';
import {NotificationsComponent} from '@modules/main/header/notifications/notifications.component';
import {ButtonComponent} from './components/button/button.component';

import {registerLocaleData} from '@angular/common';
import localeEn from '@angular/common/locales/en';
import {UserComponent} from '@modules/main/header/user/user.component';
import {ForgotPasswordComponent} from '@modules/forgot-password/forgot-password.component';
import {RecoverPasswordComponent} from '@modules/recover-password/recover-password.component';
import {LanguageComponent} from '@modules/main/header/language/language.component';
import {PrivacyPolicyComponent} from './modules/privacy-policy/privacy-policy.component';
import {MainMenuComponent} from './pages/main-menu/main-menu.component';
import {SubMenuComponent} from './pages/main-menu/sub-menu/sub-menu.component';
import {MenuItemComponent} from './components/menu-item/menu-item.component';
import {DropdownComponent} from './components/dropdown/dropdown.component';
import {DropdownMenuComponent} from './components/dropdown/dropdown-menu/dropdown-menu.component';
import { HomeComponent } from '@pages/home/home.component';
import { UserProfileComponent } from '@pages/user-profile/user-profile.component';
import {ListVehicleComponent } from '@pages/list-vehicle/list-vehicle.component';
import { AddVehicleComponent } from '@pages/add-vehicle/add-vehicle.component';
import {NgxPaginationModule} from 'ngx-pagination';
import { AddTrainingComponent } from '@pages/add-training/add-training.component';

import { ListTrainingComponent } from '@pages/list-training/list-training.component';
import { AddTestingComponent } from '@pages/add-testing/add-testing.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from '@services/interceptor';
import { FswDashboardComponent } from '@pages/fsw-dashboard/fsw-dashboard.component';

import { ListTestingComponent } from '@pages/list-testing/list-testing.component';
import { ViewSampleDetailComponent } from '@pages/view-sample-detail/view-sample-detail.component';
import { AddAwpComponent } from '@pages/add-awp/add-awp.component';
import { ListAwpComponent } from '@pages/list-awp/list-awp.component';
import { ViewDocComponent } from '@pages/view-doc/view-doc.component';
import { AddUserComponent } from '@pages/add-user/add-user.component';
import { EditUserComponent } from '@pages/edit-user/edit-user.component';
import { AdminDashboardComponent } from '@pages/admin-dashboard/admin-dashboard.component';
import { SoDashboardComponent } from './pages/so-dashboard/so-dashboard.component';
import { VerifyAccountComponent } from '@pages/verify-account/verify-account.component';
import { ChartsModule } from 'ng2-charts';
import { ListVehicleStatewiseComponent } from './pages/list-vehicle-statewise/list-vehicle-statewise.component';
import { ListTestingStatewiseComponent } from './pages/list-testing-statewise/list-testing-statewise.component';
import { ListTrainingStatewiseComponent } from './pages/list-training-statewise/list-training-statewise.component';
import { RegDashboardComponent } from './pages/reg-dashboard/reg-dashboard.component';
import { ListAwpStatewiseComponent } from './pages/list-awp-statewise/list-awp-statewise.component';
import { AddManpowerComponent } from './pages/add-manpower/add-manpower.component';
import { AddEquipmentsComponent } from './pages/add-equipments/add-equipments.component';
import { AddTestingcapabilityComponent } from './pages/add-testingcapability/add-testingcapability.component';
import { UpdateFswStatusComponent } from './pages/update-fsw-status/update-fsw-status.component';
import {AgmCoreModule, AgmMap, MapsAPILoader} from '@agm/core';
import { LocationTestComponent } from './components/location-test/location-test.component';
import { FswStatusComponent } from './pages/fsw-status/fsw-status.component';
import { EditFswStatusComponent } from './pages/fsw-status/edit-fsw-status/edit-fsw-status.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { NewProductComponent } from './pages/new-product/new-product.component';
import { ProductVsParameterComponent } from './pages/product-vs-parameter/product-vs-parameter.component';
import { ListVehicleStatewiseHomeComponent } from './pages/list-vehicle-statewise-home/list-vehicle-statewise-home.component';
import { ListVehicleHomeComponent } from './pages/list-vehicle-home/list-vehicle-home.component';
import { PopUpComponent } from './pop-up/pop-up.component';
import { HomeHindiComponent } from '@pages/home-hindi/home-hindi.component';

registerLocaleData(localeEn, 'en-EN');

@NgModule({
    declarations: [
        AppComponent,
        MainComponent,
        LoginComponent,
        HeaderComponent,
        FooterComponent,
        MenuSidebarComponent,
        BlankComponent,
        ProfileComponent,
        RegisterComponent,
        DashboardComponent,
        MessagesComponent,
        NotificationsComponent,
        ButtonComponent,
        UserComponent,
        ForgotPasswordComponent,
        RecoverPasswordComponent,
        LanguageComponent,
        PrivacyPolicyComponent,
        MainMenuComponent,
        SubMenuComponent,
        MenuItemComponent,
        DropdownComponent,
        DropdownMenuComponent,
        HomeComponent,
        UserProfileComponent,
        ListVehicleComponent,
        AddVehicleComponent,
        ListTrainingComponent,
        AddTestingComponent,
        FswDashboardComponent,
        AddTrainingComponent,
        ListTestingComponent,
        AddVehicleComponent,
        ListVehicleComponent,
        ViewSampleDetailComponent,
        AddAwpComponent,
        ListAwpComponent,
        ViewDocComponent,
        UserProfileComponent,
        AddUserComponent,
        EditUserComponent,
        AdminDashboardComponent,
        SoDashboardComponent,
        VerifyAccountComponent,
        ListVehicleStatewiseComponent,
        ListTestingStatewiseComponent,
        ListTrainingStatewiseComponent,
        RegDashboardComponent,
        ListAwpStatewiseComponent,
        AddManpowerComponent,
        AddEquipmentsComponent,
        AddTestingcapabilityComponent,
        UpdateFswStatusComponent,
        LocationTestComponent,
        FswStatusComponent,
        EditFswStatusComponent,
        ContactUsComponent,
        AboutUsComponent,
        NewProductComponent,
        ProductVsParameterComponent,
        ListVehicleStatewiseHomeComponent,
        ListVehicleHomeComponent,
        PopUpComponent,
        HomeHindiComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        AppRoutingModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
            preventDuplicates: true
        }),
        NgxSpinnerModule,
        NgxPaginationModule,
        AutocompleteLibModule,
        FormsModule,
        NgSelectModule,
        ChartsModule,
        AgmCoreModule.forRoot({  
            apiKey: 'AIzaSyAchTE1srvRYUvvzqOhiUB4fP-Sm4xelTI',
            libraries: ['places']
          }), 
    ],
    providers: [{
        provide: HTTP_INTERCEPTORS, 
        useClass: AuthInterceptor, 
        multi: true
      }],
    bootstrap: [AppComponent]
})
export class AppModule {}
